import { render, staticRenderFns } from "./FaqTable.vue?vue&type=template&id=1b081714&scoped=true"
import script from "./FaqTable.vue?vue&type=script&lang=js"
export * from "./FaqTable.vue?vue&type=script&lang=js"
import style0 from "./FaqTable.vue?vue&type=style&index=0&id=1b081714&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b081714",
  null
  
)

export default component.exports